import { Download, FileText } from 'lucide-react';
import type { Api, GuestProfileResponse } from '@/shared/api';
import { formatDateTime } from '@/shared/lib/format';
import { SectionCard } from './SectionCard';
import { downloadGuestDocument } from './downloadGuestDocument';
import { ID_KIND_LABEL } from './guestLabels';

interface DocumentsCardProps {
  api: Api;
  guest: GuestProfileResponse;
}

// Gast-Dokumente (Pass/ID/Vertrag). Upload laeuft ausschliesslich ueber das Gast-Onboarding,
// daher hier kein Upload-Button — nur Ansicht + verschluesselter Download. Ohne geladenes
// Gastprofil steht die Karte nicht da: „keine Dokumente“ wäre dann eine Behauptung.
export function DocumentsCard({ api, guest }: DocumentsCardProps) {
  const documents = guest.documents ?? [];
  return (
    <SectionCard icon="Database" title="Dokumente">
      {documents.length === 0 ? (
        <div className="border-hairline rounded-control border border-dashed px-4 py-8 text-center">
          <p className="text-ink-soft text-sm">Keine Dokumente hochgeladen.</p>
          <p className="text-ink-soft mt-1 text-xs">
            Reisepass oder Ausweis lädt der Gast im Onboarding hoch; sie liegen verschlüsselt ab.
          </p>
        </div>
      ) : (
        <ul className="space-y-2 text-sm">
          {documents.map((d) => {
            const label = ID_KIND_LABEL[d.kind] ?? d.kind;
            return (
              <li key={d.id} className="flex items-center gap-3">
                <FileText
                  size={16}
                  strokeWidth={2}
                  aria-hidden
                  className="text-ink-soft shrink-0"
                />
                <div className="min-w-0 flex-1">
                  <div className="truncate font-semibold">{label}</div>
                  <div className="text-ink-soft text-xs">
                    {(d.sizeBytes / 1024).toFixed(0)} KB · verschlüsselt ·{' '}
                    {formatDateTime(d.createdAt)}
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() => downloadGuestDocument(api, guest.id, d)}
                  className="text-ink-soft hover:text-ink rounded-control grid size-11 shrink-0 place-items-center transition-colors motion-reduce:transition-none"
                  aria-label={`${label} herunterladen`}
                >
                  <Download size={15} strokeWidth={2} aria-hidden />
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </SectionCard>
  );
}
